import { render } from "./Question.vue?vue&type=template&id=183f92d0&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=183f92d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183f92d0"],['__file',"src/views/private/questionnaire/Question.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "183f92d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('183f92d0', __exports__)) {
    api.reload('183f92d0', __exports__)
  }
  
  module.hot.accept("./Question.vue?vue&type=template&id=183f92d0&scoped=true", () => {
    api.rerender('183f92d0', render)
  })

}


export default __exports__